import { render, staticRenderFns } from "./AboutEvent.vue?vue&type=template&id=3f989d41&scoped=true"
import script from "./AboutEvent.vue?vue&type=script&lang=js"
export * from "./AboutEvent.vue?vue&type=script&lang=js"
import style0 from "./AboutEvent.vue?vue&type=style&index=0&id=3f989d41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f989d41",
  null
  
)

export default component.exports